import { Component, OnInit, ViewChild } from '@angular/core';
import { KycResultsAPIReq } from '../kyc-link-results/kyc-link-results.model';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { KycResultResponse } from '../kyc-hyperverge/kyc-hyperverge.model';
import { Globals } from '../globals';
import { KycHypervergeService } from '../kyc-hyperverge/kyc-hyperverge.service';
import { FormGroup, FormControl, NgForm } from '@angular/forms';
import { GenerateLinkReq, GenerateLinkRes, SendLinkRes, SendLinktoCustomerReq } from '../kyc-search/kyc-search.model';

@Component({
  selector: 'app-kyc-customer-search',
  templateUrl: './kyc-customer-search.component.html',
  styleUrls: ['./kyc-customer-search.component.css']
})
export class KycCustomerSearchComponent implements OnInit {

  @ViewChild('kycDetailsForm') kycDetailsForm: any;
  showValidationMsgs: boolean = false;
  isLoading: boolean = false;
  uniqueId: string;
  status: string;
  kycResultsAPIReq: any;
  kycResultsAPIRes: KycResultResponse;
  errMsg: string;
  successMsg:string;
  mobileNo: string;
  emailId: string;
  sendLinkReq: SendLinktoCustomerReq;
  sendLinkResponse: SendLinkRes;
  kycStatus: string;
  generateLinkReq: GenerateLinkReq;
  url: string;
  isOpenKYCModal: boolean = false;

  constructor(private route: ActivatedRoute, public globals: Globals, public kycHypervergeService: KycHypervergeService,public router: Router) {
    this.kycResultsAPIReq = new KycResultsAPIReq();
    this.kycResultsAPIRes = new KycResultResponse();
    this.sendLinkReq = new SendLinktoCustomerReq();
    this.generateLinkReq = new GenerateLinkReq();
  }

  ngOnInit(): void {
    window.scroll({ top: 0, left: 0, behavior: 'smooth' });
  }

  submitKycDetails(kycDetailsForm: NgForm, isValid) {
    if (!isValid) {
      this.showValidationMsgs = true;
      this.validateAllFields(kycDetailsForm.form);
    } else {
      this.kycResultDetails();
    }
  }

  validateAllFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFields(control);
      }
    });
  }

  kycResultDetails() {
    this.errMsg = "";
    this.kycStatus = "";
    this.isOpenKYCModal = false;
    this.isLoading = true;
    this.successMsg = "";
    this.kycHypervergeService.getKycStatusResults(this.kycResultsAPIReq).subscribe((data: any) => {
      this.isLoading = false;
      this.kycResultsAPIRes = JSON.parse(JSON.stringify(data));
      if(this.kycResultsAPIRes.errMessage && this.kycResultsAPIRes.errMessage == 'KYC request has not yet received') {
        this.errMsg = this.kycResultsAPIRes.errMessage;
      } else {
        if(this.kycResultsAPIRes.applicationStatus == 'auto_approved' || this.kycResultsAPIRes.applicationStatus == 'manually_approved' || this.kycResultsAPIRes.applicationStatus == 'success' || this.kycResultsAPIRes.applicationStatus == 'Success') {
          this.kycStatus = 'KYC Verified';
          //this.isOpenKYCModal = true;
          this.successMsg = "KYC Completed"
        } else {
          this.kycStatus = 'KYC Pending';
          this.generateLink();
        }
      }
    });
  }

  onLogOut() {
    sessionStorage.clear();
    window.location.reload();
    this.router.navigate(['/logout']);
  }

  generateLink() {
    this.url = "";
    this.errMsg = "";
    this.generateLinkReq.customerType = this.kycResultsAPIRes.customerType;
    this.generateLinkReq.dateOfBirth = this.kycResultsAPIRes.dob;
    this.generateLinkReq.emailId = this.kycResultsAPIRes.email;
    this.generateLinkReq.mobileNo = this.kycResultsAPIRes.mobile;
    this.generateLinkReq.panNumber = this.kycResultsAPIRes.pan;
    this.generateLinkReq.uniqueId = this.kycResultsAPIRes.uniqueId;
    this.isLoading = true;
    this.kycHypervergeService.generateLink(this.generateLinkReq).subscribe((data: GenerateLinkRes) => {
      this.isLoading = false;
      if(data != null && data.errMsg != '' && data.errMsg != null && data.errMsg != undefined) {
        this.errMsg = data.errMsg+" to generate the KYC Link";
      } else {
        this.url = data.url;
        window.location.href = data.url;
      }
    });
  }

  closeKYCModal() {
    this.isOpenKYCModal = false;
  }
}
